export default __webpack_public_path__ + "static/BlogBanner-9359164acde66117fcf4eeed2df7a751.gif";